import { render, staticRenderFns } from "./PricingTableLegacy.vue?vue&type=template&id=4f57ce17&"
import script from "./PricingTableLegacy.vue?vue&type=script&lang=js&"
export * from "./PricingTableLegacy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports